import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LOADER_FEATURE_KEY, LoaderState } from './ngrx-loader.reducer';

const getLoaderState = createFeatureSelector<LoaderState>(LOADER_FEATURE_KEY);

export const isLoaderVisible = createSelector(
  getLoaderState,
  (state: LoaderState) => state.active > 0,
);

export const getLoaderText = createSelector(
  getLoaderState,
  (state: LoaderState) => state.text,
);
